/* eslint-disable max-lines-per-function */
import './PROD.scss';
import {PageManager} from '@mvps-genesis/bootstrap';
import ProductImageGallery from 'extensions/product-image-gallery';

export default class PROD extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {

		/**
		 * Initialize Main-Image, Thumbnails, & PhotoSwipe Close-up Gallery
		 */
		new ProductImageGallery({
			videos: this.pageContext.Product_Videos || []
		});

		this.initPurchaseForm();
		this.initStickyHeader();

		/**
		 * This removes the default Miva `closeup_backing` container.
		 */
		var closeupBacking = document.querySelector('div.closeup_backing');

		window.addEventListener('load', function () {
			if (closeupBacking) {
				closeupBacking.parentNode.removeChild(document.querySelector('div.closeup_backing'));
			}
		});

		this.mivaEventsListener();
		this.initQuantify();
		this.initShortDesc();
		this.initTabs();
		this.initSubscriptions();

	}

	async initPurchaseForm () {
		const purchaseForm = document.getElementById('js-purchase-form');

		if (!purchaseForm) {
			return;
		}

		// Initialize ajax add to cart functionality
		if (purchaseForm.querySelector('.js-add-to-cart')) {
			const {default: AjaxAddToCart} = await import('extensions/ajax-add-to-cart');

			new AjaxAddToCart(purchaseForm, {
				scrollToMessage: 'error'
			});
		}

		const {HTMLFormValidator} = await import('extensions/form-validation');

		new HTMLFormValidator({
			fieldContainer: '.g-product-layout-purchase__options-attribute',
			formElement: purchaseForm
		});
	}

	async initStickyHeader () {
		const stickyHeaderElement = document.getElementById('js-sticky-header');
		const atcElement = document.getElementsByClassName('js-add-to-cart')[0];

		if (!stickyHeaderElement || !atcElement || !('IntersectionObserver' in window)) {
			return;
		}

		const {default: ProductStickyHeader} = await import('extensions/product-sticky-header');

		new ProductStickyHeader(stickyHeaderElement, {
			targetAddToCartElement: atcElement
		});
	}

	mivaEventsListener () {

		const observer = new MutationObserver((_mutations, mo) => {
			if (typeof window.MivaEvents !== 'undefined') {
				mo.disconnect();

				// eslint-disable-next-line new-cap
				window.MivaEvents.SubscribeToEvent('variant_changed', (productData) => this.variantChanged(productData));
			}
		});

		observer.observe(document, {
			childList: true,
			subtree: true
		});

	}

	variantChanged (productData) {

		this.updateVariantURL(productData.variant_id);

	}

	updateVariantURL (variantId) {

		let newSearch = '';

		if ((/variant_id=\d+/).test(window.location.search)) {
			newSearch = window.location.search.replace(/variant_id=\d+/, 'variant_id=' + variantId);
		} else if (window.location.search) {
			newSearch = window.location.search + '&variant_id=' + variantId;
		} else {
			newSearch = '?variant_id=' + variantId;
		}

		window.history.replaceState(null, '', window.location.pathname + newSearch + window.location.hash);

	}

	async initQuantify () {
		const {Quantify} = await import('extensions/quantify');

		new Quantify();
	}

	async initShortDesc () {

		const shortDescElement = document.querySelector('.g-short-desc');

		if (shortDescElement) {
			let maxWordCount = parseInt(shortDescElement.getAttribute('data-max-word-count'), 10);

			if (isNaN(maxWordCount)) {
				maxWordCount = 20;
			}

			const {default: ShortDesc} = await import('extensions/short-description');

			new ShortDesc({
				maxWordCount: maxWordCount,
				scrollToElement: false,
				shortDescElement: shortDescElement
			});
		}
	}

	async initTabs () {
		const productTabs = document.getElementsByClassName('g-tabcordion');
		const productTabsLength = productTabs.length;

		if (!productTabsLength) {
			return;
		}

		const {Tabcordion} = await import('extensions/tabs');

		for (let i = 0; i < productTabsLength; i++) {
			productTabs[i].tabcordion = new Tabcordion(productTabs[i], {
				accordionMode: 768
			});

			if (i === 0) {
				const shortDescLinkElement = document.querySelector('.g-short-desc__link');

				if (shortDescLinkElement) {
					shortDescLinkElement.addEventListener('click', (event) => {
						const hashElements = productTabs[i].tabcordion.getElementsByHash(shortDescLinkElement.hash);

						if (hashElements) {
							event.preventDefault();

							productTabs[i].tabcordion.showPanel(hashElements, {
								scrollIntoView: productTabs[i].tabcordion.hashOptions.scrollIntoView
							});
						}
					});
				}
			}
		}
	}

	initSubscriptions () {
		const subTermElement = document.getElementById('js-subscription-terms');
		const subChoiceElements = document.getElementsByClassName('js-subscription-choice');

		if (!subTermElement || !subChoiceElements.length) {
			return;
		}

		const subtermOptionsElement = subTermElement.querySelector('[name="Product_Subscription_Term_ID"]');

		if (!subtermOptionsElement) {
			return;
		}

		const subTermControlElementId = 'js-subscription-term-control';

		for (const element of subChoiceElements) {
			element.addEventListener('click', () => {
				if (element.id === subTermControlElementId && element.checked) {
					subTermElement.removeAttribute('hidden');
					subtermOptionsElement.disabled = false;
				} else {
					subTermElement.setAttribute('hidden', '');
					subtermOptionsElement.disabled = true;
				}
			});
		}
	}

}
